// src/components/InspectionBookingReport.js
import React, { Component, createRef } from 'react';
import axios from 'axios';
import axiosInstance from "./axiosConfig";
import {
  Box, Button, Typography, TextField, Table, TableHead,
  TableRow, TableCell, TableBody, TablePagination,
  InputAdornment
} from '@mui/material';
import dayjs from 'dayjs';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { Navigate  } from 'react-router-dom';
import Serverurl from './Apiurl';
import searchIcon from './images/SEARCH.png';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
const STATUS_LABELS = {
  1: 'New',
  2: 'Assigned',
  3: 'Completed',
  4: 'Not Interested',
  5: 'Postponed',
  6: 'Reassigned'
};
const getStatusLabel = status => STATUS_LABELS[status] || 'Unknown';
class InspectionBookingReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bookings: [],
      totalItems: 0,
      page: 0,
      rowsPerPage: 5,
      searchPhoneEmail: '',
      searchDate: null,
      searchStatus: '',

  DCrole: localStorage.getItem("DCrole"),
  DCuserid: localStorage.getItem("DCuserid"),
      slots: [],
    };
    this.tableRef = createRef();
  }
  componentDidMount() {
    document.title = "Prep for Sale- Staff Management";
    if(localStorage.getItem("DCuserid")==null) {
      this.setState({ logredirect: true, pagename:'/' });
    }
    this.fetchBookings();
    this.fetchSlots();
  }
fetchBookings = () => {
  const {
    page,
    rowsPerPage,
    searchPhoneEmail,
    searchDate,
    searchStatus,
    DCrole,
    DCuserid
  } = this.state;

  const params = {
    page,
    limit: rowsPerPage,
    ...(searchPhoneEmail && { search: searchPhoneEmail }),
    ...(searchDate && {
      ib_date: dayjs.isDayjs(searchDate)
        ? searchDate.format("YYYY-MM-DD")
        : searchDate
    }),
    ...(searchStatus && { status: searchStatus })
  };

   if (localStorage.getItem("DCrole") === "3") {
    params.staff_id = localStorage.getItem("DCuserid");
  }

  axiosInstance
    .get(Serverurl + "inspectionbooking/inspectiongetall", { params })
    .then((res) => {
      const { bookings, totalCount } = res.data;
      this.setState({
        bookings,
        totalItems: totalCount
      });
    })
    .catch((err) => console.error("Error fetching bookings:", err));
};
  fetchSlots = () => {
    axiosInstance.get(Serverurl+'slotmanagement/slotmanagementall')
      .then(res => this.setState({ slots: res.data }));
  }
  handleChangePage = (_, newPage) => {
    this.setState({ page: newPage }, this.fetchBookings);
  }
  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: parseInt(event.target.value, 10), page: 0 }, this.fetchBookings);
  }
  handleSearchClick = () => {
    this.setState({ page: 0 }, this.fetchBookings);
  }
  render() {
    if (this.state.logredirect === true) {
      return <Navigate to={this.state.pagename} />
    }
    const { bookings } = this.state;
    return (
      <div className="maincontentDiv">
        <Typography pt={2} pb={2} className="contentHeading" variant="h5" gutterBottom>Inspection Bookings Report</Typography>
        {/* Search Section */}
        <Box sx={{
          display: 'flex',
          gap: 2,
          mb: 3,
          flexWrap: 'wrap',
          alignItems: 'center',
          justifyContent: 'flex-start'
        }}>
          <Box className="contentSearch" sx={{ display: 'flex', flexDirection: 'column', width: "230px" }}>
            <Typography variant="body1">Date</Typography>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker			  
                value={this.state.searchDate}
				size="small"
                onChange={(newValue) => this.setState({ searchDate: newValue })}
                 format="DD-MM-YYYY" 
                disableMaskedInput={false}
                renderInput={(params) => <TextField {...params} size="small" />}   
slotProps={{ textField: { size: "small" } }}				
              />
            </LocalizationProvider>
          </Box>
          {/* Search by Name/Email */}
          <Box  sx={{ display: "flex", flexDirection: "column", width: "230px" }}>
            <Typography variant="body1" sx={{ mb: 0.5 }}>Name / Email / Phone</Typography>
            <TextField
              value={this.state.searchPhoneEmail}
              onChange={e => this.setState({ searchPhoneEmail: e.target.value })}
              size="small"
              placeholder="Search"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={searchIcon} alt="Search" />
                  </InputAdornment>
                ),
              }}
            />
          </Box>
          {/* Search by Status */}
          <Box sx={{ display: "flex", flexDirection: "column", width: "230px"  }}>
            <Typography variant="body1">Status</Typography>
            <TextField
              select
              variant="outlined"
              size="small"
              value={this.state.searchStatus}
              onChange={e => this.setState({ searchStatus: e.target.value })}
              SelectProps={{ native: true }}
            >
              <option value="">All</option>
              <option value="1">New</option>
              <option value="2">Assigned</option>
              <option value="3">Completed</option>
              <option value="4">Not Interested</option>
              <option value="6">Reassigned</option>
            </TextField>
          </Box>
          {/* Buttons */}
          <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
            <Button variant="contained"  className="frmPrimarybtn" onClick={this.handleSearchClick}>Search</Button>
            <DownloadTableExcel
              filename="Inspection_Booking"
              sheet="Inspection"
              currentTableRef={this.tableRef.current}
            >
              <Button variant="contained" className="frmPrimarybtn">Export</Button>
            </DownloadTableExcel>
          </Box>
        </Box>
        {/* Table */}
        <Table ref={this.tableRef}>
          <TableHead>
            <TableRow>
			<TableCell>Name</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Address</TableCell>
			  <TableCell>Service</TableCell>
              <TableCell>Date</TableCell>
              <TableCell>Slot</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bookings.length === 0 ? (
              <TableRow>
                <TableCell colSpan={6} align="center">No requests found.</TableCell>
              </TableRow>
            ) : (
              bookings.map((booking) => {
                const statusNum = Number(booking.sa_status);
                return (
                  <TableRow key={booking.ib_id}>
				  <TableCell>{booking.customerName}</TableCell>
                    <TableCell>{booking.ib_phoneno}</TableCell>
                    <TableCell>{booking.ib_email}</TableCell>
                    <TableCell>{booking.ib_address}</TableCell>
					<TableCell>
  {booking.ib_sm_id
    ? (booking.serviceName || "N/A")
    : "Inspection"}
</TableCell>
                    <TableCell>{dayjs(booking.ib_date).format('DD-MM-YYYY')}</TableCell>
                    <TableCell>{booking.slotInfo?.[0]?.sl_title || 'N/A'}</TableCell>
                    <TableCell>{getStatusLabel(statusNum)}</TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
        <TablePagination
          component="div"
          count={this.state.totalItems}
          page={this.state.page}
          onPageChange={this.handleChangePage}
          rowsPerPage={this.state.rowsPerPage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
          rowsPerPageOptions={[5, 10, 20]}
        />
      </div>
    );
  }
}
export default InspectionBookingReport;